import Vue from 'vue'
import store from './store'
import App from './App.vue'
import Router from 'vue-router'
import router from './router'
import Vuex from 'vuex'
import Vuelidate from 'vuelidate'
import VueToast from 'vue-toast-notification'

import 'vue-toast-notification/dist/theme-sugar.css'
import './assets/theme.css'

Vue.config.productionTip = false

Vue.use( Router );
Vue.use( Vuelidate);
Vue.use( Vuex );
Vue.use( VueToast, {
  position: 'top'
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
